import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/i18n";

export default function EmptyStateMessage() {
    const { t, localizePath } = useI18n();
    return (
        <div className="emptyStateCard">
            <div className="emptyStateIcon" aria-hidden="true">🏋️‍♂️</div>
            <p className="emptyStateTitle">{t("home.emptyStateTitle")}</p>
            <Link
                to={localizePath("/SelectExercise")}
                className="appButton homeActionButton"
            >
                <span>{t("home.logExercise")}</span>
                <span className="homeActionButtonSymbol" aria-hidden="true">+</span>
            </Link>
        </div>
    );
}
